/** Handle document creation here */

import { object, string, bool } from 'prop-types';
import * as React from 'react';
import OnlineRehabilitationStepper from '../Stepper';

class StepperWrapper extends React.Component {
  // createNewOnlineRehab() {
  //   this.props.onCreate && this.props.onCreate('onlineRehabilitation');
  // }
  // startEditingOnlineRehab(id) {
  //   this.props.onStartEdit && this.props.onStartEdit('onlineRehabilitation', id);
  // }

  // componentDidMount() {
  //   const { editingDocumentId } = this.props;

  //   if (this.props.documents) {
  //     if (this.props.documents.length === 0) {
  //       this.createNewOnlineRehab(); // Create new online rehab if none exists
  //     } else if (!editingDocumentId && this.props.documents.length === 1) {
  //       // Start editing existing online rehab if one is not being edited
  //       this.startEditingOnlineRehab(this.props.documents[0].documentId);
  //     }
  //   } else {
  //     this.createNewOnlineRehab(); // Create new online rehab if none exists
  //   }
  // }
  render() {
    const { editingDocumentId, viewingId, editedCommit, hasDiaryBeenFilled, documentData } = this.props;
    return (
      <OnlineRehabilitationStepper
        editingDocumentId={editingDocumentId}
        viewingId={viewingId}
        editedCommit={editedCommit}
        hasDiaryBeenFilled={hasDiaryBeenFilled}
        documentData={documentData}
      />
    );
  }
}

StepperWrapper.propTypes = {
  editingDocumentId: string, // From <Editable />
  viewingId: string, // From <Editable />
  editedCommit: object,
  hasDiaryBeenFilled: bool,
  documentData: object,
};

export default StepperWrapper;
